import { render } from "./ComentariosFiltro_cat.vue?vue&type=template&id=95f89da2&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"personal\":\"data\",\"asignarValor\":\"options\",\"asignarSector\":\"options\",\"obtenerPersonal\":\"options\",\"refrescarPersonal\":\"options\"}"
import script from "./ComentariosFiltro_cat.vue?vue&type=script&lang=js"
export * from "./ComentariosFiltro_cat.vue?vue&type=script&lang=js"
script.render = render

export default script